@if (isGoogleEngine) {
    <h-map-google-display
        [mapEvent$]="mapEvent$"
        [markers]="markers"
        [displayZoom]="displayZoom"
        [isZoomOnClickActive]="isZoomOnClickActive"
        [isMarkerClustererActive]="isMarkerClustererActive"
        [hasFullScreenButton]="hasFullScreenButton"
        [isInMobile]="isInMobile"
        (markersCoordinatesInBounds)="markersCoordinatesInBounds.emit($event)"
        (hoveredMarkerCoordinates)="hoveredMarkerCoordinates.emit($event)"
        (unhoveredMarkerCoordinates)="unhoveredMarkerCoordinates.emit($event)"
        (mapInitialized)="mapInitialized.emit($event)"
        (clickedMarkerCoordinates)="clickedMarkerCoordinates.emit($event)">
    </h-map-google-display>
} @else {
    <h-map-baidu-display
        [mapEvent$]="mapEvent$"
        [markers]="markers"
        [isInMobile]="isInMobile"
        [isZoomOnClickActive]="isZoomOnClickActive"
        [isMarkerClustererActive]="isMarkerClustererActive"
        (mapInitialized)="mapInitialized.emit($event)"
        (markersCoordinatesInBounds)="markersCoordinatesInBounds.emit($event)"
        (hoveredMarkerCoordinates)="hoveredMarkerCoordinates.emit($event)"
        (unhoveredMarkerCoordinates)="unhoveredMarkerCoordinates.emit($event)"
        (clickedMarkerCoordinates)="clickedMarkerCoordinates.emit($event)">
    </h-map-baidu-display>
}
